import React, { Fragment } from 'react'
import currency from 'currency.js'
import { Element as ScrollElement } from 'react-scroll'
import Favorite from '../community/Favorite'
import FriendLabel from '../community/FriendLabel'
import { Action } from '@foodsby/nutrient'

export const MenuListItem = ({
  item: { id, name, price, description },
  availableFavorites,
  onSelectMenuItem,
  addFavoriteStart,
  deleteFavoriteStart,
  favorites,
  favoriteLoading,
  menuItems,
  isWebpSupported,
}) => (
  <Fragment>
    <li className="placeorder-item">
      {favorites && favorites.length >= 1 ? (
        <Favorite
          classNames={{ 'placeorder-item_favorite': true }}
          deleteFavoriteStart={deleteFavoriteStart}
          favoriteLoading={favoriteLoading}
          id={id}
        />
      ) : availableFavorites && availableFavorites.length > 0 ? (
        <Favorite
          addFavoriteStart={addFavoriteStart}
          classNames={{ 'placeorder-item_favorite': true }}
          favoriteLoading={favoriteLoading}
          id={id}
        />
      ) : null}
      <Action
        onClick={evt => {
          evt.preventDefault()
          onSelectMenuItem(id)
        }}
      >
        <div className="row">
          <div className="col-xs-10 placeorder-item_title">{name}</div>
          <div className="col-xs-2 end-xs placeorder-item_price">
            {currency(price).format()}
          </div>
        </div>
        <div className="col-xs-12 placeorder-item_description">
          {description}
        </div>
        {menuItems && (
          <div className="friendMenuItemContainer">
            {menuItems.slice(0, 3).map((friendsOrder, index) => (
              <div className="friendLabel" key={index}>
                <FriendLabel
                  avatarId={friendsOrder.friend.avatarId}
                  email={friendsOrder.friend.email}
                  firstName={friendsOrder.friend.firstName}
                  isWebpSupported={isWebpSupported}
                  lastName={friendsOrder.friend.lastName}
                  showEmail={false}
                  showName={false}
                />
              </div>
            ))}
            {menuItems.length > 3 && (
              <span> + {menuItems.length - 3} more</span>
            )}
          </div>
        )}
      </Action>
    </li>
  </Fragment>
)

MenuListItem.defaultProps = {
  item: {},
}

export const MenuList = ({
  items,
  onSelectMenuItem,
  availableFavorites,
  addFavoriteStart,
  favorites,
  friendHasOrdered,
  deleteFavoriteStart,
  menuItemIdsLoading = [],
  isWebpSupported,
}) => (
  <ul className="placeorder-list">
    {items.map(item => (
      <MenuListItem
        addFavoriteStart={addFavoriteStart}
        availableFavorites={
          availableFavorites &&
          availableFavorites.filter(favorite => favorite.menuItemId === item.id)
        }
        deleteFavoriteStart={deleteFavoriteStart}
        favoriteLoading={menuItemIdsLoading.find(
          menuItem => menuItem.menuItemId === item.id,
        )}
        favorites={
          favorites &&
          favorites.filter(favorite => favorite.menuItemId === item.id)
        }
        isWebpSupported={isWebpSupported}
        item={item}
        key={item.id}
        menuItems={
          friendHasOrdered &&
          friendHasOrdered.friendsOrders &&
          friendHasOrdered.friendsOrders.filter(friendOrder =>
            friendOrder.orderItems
              .map(orderItem => orderItem.menuItemId)
              .includes(item.id),
          )
        }
        onSelectMenuItem={onSelectMenuItem}
      />
    ))}
  </ul>
)

MenuList.defaultProps = {
  items: [],
}

export const MenuSection = ({
  section: { id, name, description, menuItems },
  availableFavorites,
  onSelectMenuItem,
  addFavoriteStart,
  deleteFavoriteStart,
  favorites,
  friendHasOrdered,
  menuItemIdsLoading,
  isWebpSupported,
}) => (
  <ScrollElement name={`${id}`}>
    <section id={`menu-section-${id}`}>
      <h2 className="placeorder-header">{name}</h2>
      <p className="placeorder-description">{description}</p>
      <MenuList
        addFavoriteStart={addFavoriteStart}
        availableFavorites={availableFavorites}
        deleteFavoriteStart={deleteFavoriteStart}
        favorites={favorites}
        friendHasOrdered={friendHasOrdered}
        isWebpSupported={isWebpSupported}
        items={menuItems}
        menuItemIdsLoading={menuItemIdsLoading}
        onSelectMenuItem={onSelectMenuItem}
      />
    </section>
  </ScrollElement>
)

MenuSection.defaultProps = {
  section: {},
}

export const Menu = ({
  menuData,
  onSelectMenuItem,
  availableFavorites,
  addFavoriteStart,
  favorites,
  friendHasOrdered,
  deleteFavoriteStart,
  menuItemIdsLoading,
  isWebpSupported,
}) => (
  <section className="placeorder">
    <div className="placeorder-menu">
      {menuData.subMenus.map(submenu => (
        <MenuSection
          addFavoriteStart={addFavoriteStart}
          availableFavorites={availableFavorites}
          deleteFavoriteStart={deleteFavoriteStart}
          favorites={favorites}
          friendHasOrdered={friendHasOrdered}
          isWebpSupported={isWebpSupported}
          key={submenu.id}
          menuItemIdsLoading={menuItemIdsLoading}
          onSelectMenuItem={onSelectMenuItem}
          section={submenu}
        />
      ))}
    </div>
  </section>
)

Menu.defaultProps = {
  menuData: {
    subMenus: [],
  },
}

export default Menu
